import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

// Panier persistant (localStorage), sans paiement : la commande est envoyée
// à la maison par e-mail via /api/commande.php, qui revient vers le client.
const KEY = "partita-cart-v1";
const CartContext = createContext(null);

function load() {
  try {
    const raw = localStorage.getItem(KEY);
    const items = raw ? JSON.parse(raw) : [];
    return Array.isArray(items) ? items.filter((i) => i && i.reference && i.qty > 0) : [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* stockage indisponible */ }
  }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((list) => {
      const i = list.findIndex((x) => x.reference === product.reference);
      if (i >= 0) {
        const next = [...list];
        next[i] = { ...next[i], qty: Math.min(99, next[i].qty + qty) };
        return next;
      }
      return [...list, {
        reference: product.reference,
        label: product.label,
        collection: product.collection,
        price: product.price,
        url: product.url,
        qty: Math.min(99, qty),
      }];
    });
  }, []);

  const setQty = useCallback((reference, qty) => {
    setItems((list) =>
      qty <= 0
        ? list.filter((x) => x.reference !== reference)
        : list.map((x) => (x.reference === reference ? { ...x, qty: Math.min(99, qty) } : x))
    );
  }, []);

  const remove = useCallback((reference) => setQty(reference, 0), [setQty]);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => {
    const count = items.reduce((n, i) => n + i.qty, 0);
    const total = items.reduce((n, i) => n + i.qty * (Number(i.price) || 0), 0);
    return { items, count, total, add, setQty, remove, clear };
  }, [items, add, setQty, remove, clear]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart hors CartProvider");
  return ctx;
}

export const euro = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
